import React, { FC } from 'react'

import { IconSvgProps } from './icon'

export const IconInvoice: FC<IconSvgProps> = ({
    size = 24,
    color = 'var(--text-and-icon-primary)',
}) => {
    return (
        <svg
            fill='none'
            height={size}
            viewBox='0 0 24 24'
            width={size}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15 9H9C8.45 9 8 8.5525 8 8C8 7.4475 8.45 7 9 7H15C15.55 7 16 7.4475 16 8C16 8.5525 15.55 9 15 9Z'
                fill={color}
            />
            <path
                d='M9 13.0001H15C15.55 13.0001 16 12.5525 16 12C16 11.4475 15.55 11 15 11H9C8.45 11 8 11.4475 8 12C8 12.5525 8.45 13.0001 9 13.0001Z'
                fill={color}
            />
            <path
                d='M9 17H12C12.55 17 13 16.5525 13 16C13 15.4475 12.55 15 12 15H9C8.45 15 8 15.4475 8 16C8 16.5525 8.45 17 9 17Z'
                fill={color}
            />
            <path
                clipRule='evenodd'
                d='M20.0001 5C20.0001 3.343 18.6551 2.0005 17.0001 2H7.00002C5.34501 2.0005 4 3.343 4 5L4.00002 20.4843C4.00002 21.1152 4.5155 21.6266 5.15138 21.6266C5.3676 21.6266 5.57944 21.5662 5.76267 21.4523C6.03328 21.2719 6.34302 21.1574 6.66667 21.1181C7.0013 21.1621 7.32174 21.2799 7.60444 21.4629C8.12599 21.7835 8.72066 21.9682 9.33333 22C9.94646 21.9717 10.5416 21.7857 11.0604 21.4603C11.61 21.0385 12.3775 21.0385 12.9271 21.4603C13.4503 21.7862 14.0496 21.9721 14.6667 22C15.2931 21.9707 15.9014 21.7818 16.4329 21.4515C16.7028 21.2724 17.0111 21.1582 17.3333 21.1181C17.6575 21.1546 17.9678 21.269 18.2373 21.4515C18.3454 21.5192 18.4755 21.5833 18.6275 21.6439C19.1401 21.848 19.7224 21.6012 19.9281 21.0926C19.9756 20.9751 20 20.8497 20 20.7231L20.0001 5ZM6.00002 5V8H6.00275V19.4373C6.2393 19.3532 6.33162 19.3536 6.52895 19.3545C6.56965 19.3547 6.61483 19.3549 6.66667 19.3543C7.29127 19.3872 7.89761 19.5749 8.43022 19.9002C8.70303 20.0761 9.01124 20.1908 9.33333 20.2362C9.64988 20.1989 9.95268 20.0864 10.216 19.9082C10.7517 19.5722 11.3668 19.3812 12 19.3543C12.6306 19.3819 13.2432 19.5715 13.7778 19.9046C14.043 20.0842 14.3479 20.1979 14.6667 20.2362C14.9989 20.1975 15.317 20.0809 15.5947 19.8958C16.1181 19.5709 16.7167 19.3845 17.3333 19.3543C17.3831 19.3548 17.4269 19.3546 17.4666 19.3544C17.6685 19.3536 17.7645 19.3532 18.0031 19.4373V14H18.0001V5C18.0001 4.7205 17.8901 4.477 17.7051 4.293C17.5251 4.1105 17.2801 4.0005 17.0001 4H7.00002C6.72002 4.0005 6.47506 4.1105 6.29506 4.293C6.11006 4.477 6.00002 4.7205 6.00002 5Z'
                fill={color}
                fillRule='evenodd'
            />
        </svg>
    )
}
